import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";

import { Button, Toastr } from "../../revvComponents";
import {
  updateSubmitRejectSignerFillerAction,
  updateSubmitDeclineInternalAction,
  updateDocStage,
} from "../../actions/DocumentActions";
import SubmitConfirmationPopup from "./SubmitConfirmationPopup";
import RecipientSubmitDeclinePopup from "./RecipientSidePopups/RecipientSubmitDeclinePopup";
import {
  handleApiErrMsg,
  readDataFromLocalStorage,
} from "../../utils/globalUtils";
import { getExportContent } from "../../utils/documentUtils";
import {
  getSubmitSignersPayload,
  fetchSignersList,
  getSignersPayload,
} from "../../utils/quotationUtils";

// Services Imports
import {
  sharedDocAccepAndSign,
  sharedDocAfterAccepAndSign,
  getEsignCount,
} from "../../actions/SharedDocumentActions/sharedDocumentServices";
import LZLoader from "../../commonComponents/LZLoader";

class SubmitDeclineConfirmation extends Component {
  state = { isLoading: false };

  _onError = err => {
    console.error(err);
    Toastr.showToastr({
      type: "failure",
      message: handleApiErrMsg(err),
      timeout: 3000,
    });
  };

  _submitConfirmationPopup = () => {
    if (this.props.sharingHash) {
      getEsignCount(this.props.docID, this.props.sharingHash).then(res => {
        if (res.is_sandbox_allowed) {
          this.props.updateDocStage(
            this.props.view === "submit" ? "SENT" : "DECLINED",
          );

          setTimeout(() => {
            this._submitDeclineDoc(this.props.docStage);
          }, 1000);
        } else if (!res.is_sandbox_allowed && res.remaining_esigns > 0) {
          this.props.updateDocStage(
            this.props.view === "submit" ? "SENT" : "DECLINED",
          );

          setTimeout(() => {
            this._submitDeclineDoc(this.props.docStage);
          }, 1000);
        } else {
          Toastr.showToastr({
            type: "failure",
            message:
              "Something went wrong. Please contact admin for eSignature issues.",
            timeout: 3000,
          });
        }
      });
    } else {
      this.props.updateDocStage(this.props.docStage);

      setTimeout(() => {
        this._submitDeclineDoc(this.props.docStage);
      }, 1000);
    }
  };

  _submitDeclineDoc = documentStage => {
    // Make api call here
    const {
      view,
      docID,
      sharingHash,
      docName,
      document: doc,
      signatoriesV2,
      components,
      updateSubmitRejectSignerFiller,
      isSharing,
      updateSubmitDeclineInternal,
      isMobileView,
    } = this.props;

    const signersList = fetchSignersList(signatoriesV2);
    let signers;
    if (doc.document_flow === "ACCEPTANCE") {
      signers = getSubmitSignersPayload(
        signersList.map(signer => ({
          ...signer,
          user_email: signer.signer_email,
        })),
        this._onError,
      );
    } else {
      signers = getSignersPayload(
        signersList.map(signer => ({
          ...signer,
          user_email: signer.signer_email,
        })),
        this._onError,
      );
    }

    // const documentSectionHTML = document.getElementsByClassName(
    //   "document-view-main-container",
    // )[0];
    // const html =
    //   documentSectionHTML && documentSectionHTML.innerHTML.length > 0
    //     ? documentSectionHTML.innerHTML
    //     : "";

    const data = {
      esignType: "REVV",
      pdfFile: getExportContent(doc, components),
      docName,
    };
    data.pdfFile.content.signers = signers.reduce((accum, item) => {
      accum[item.user_email] = item;
      return accum;
    }, {});

    this.setState({
      isLoading: true,
    });
    if (isSharing) {
      updateSubmitRejectSignerFiller(docID, sharingHash, view, data)
        .then(res => {
          if (isMobileView)
            this.props.togglePopUp("submitDeclineConfirmation", false);
          if (this.props.view === "submit") {
            const { doc_stage: docStage, recipientType } = res;
            if (docStage === "SENT" && recipientType === "SIGNER") {
              this._acceptAndSign();
            }
            this.props.updateMultipleState({
              submitDeclineConfirmation: false,
            });
          } else if (this.props.view === "decline") {
            this.props.updateMultipleState({
              docDeclinedConfirmationPopup: true,
              submitDeclineConfirmation: false,
            });
          }
          this.setState({
            isLoading: false,
          });
        })
        .catch(res => {
          console.debug("ERROR", res);
          let message = `Oops! Couldn't ${this.props.view} document. Please try again.`;
          if (
            res &&
            res.response &&
            res.response.data &&
            res.response.data.message
          ) {
            message = res.response.data.message;
          }

          Toastr.showToastr({
            type: "failure",
            message,
            timeout: 3000,
          });
          this.setState({ isLoading: false });
          this.props.updateMultipleState({
            submitDeclineConfirmation: false,
            showSubmitAndDeclineBtn: false,
          });
        });
    } else {
      const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");

      updateSubmitDeclineInternal(
        docID,
        view,
        CURRENT_USER.id,
        data,
        documentStage,
      )
        .then(() => {
          if (this.props.view === "submit") {
            this.props.updateMultipleState({
              docSubmittedConfirmationPopup: true,
              submitDeclineConfirmation: false,
            });
          } else if (this.props.view === "decline") {
            this.props.updateMultipleState({
              docDeclinedConfirmationPopup: true,
              submitDeclineConfirmation: false,
            });
          }
          this.setState({
            isLoading: false,
          });
        })
        .catch(() => {
          Toastr.showToastr({
            className: "is-failure",
            message: `Oops! Couldn't ${this.props.view} document. Please try again.`,
            timeout: 3000,
          });
          this.setState({ isLoading: false });
          this.props.updateMultipleState({
            submitDeclineConfirmation: false,
            showSubmitAndDeclineBtn: false,
          });
        });
    }
  };

  _checkFormFields = () => {
    // if true - dont show the send confirmation popup
    const { fieldsUsed, showForm } = this.props;
    if (!fieldsUsed || !fieldsUsed.length || !showForm) {
      return true;
    }
    for (let i = 0; i < fieldsUsed.length; i += 1) {
      const element = fieldsUsed[i];
      let value = true;
      if (element.filler_type === "RECIPIENT") {
        value = element
          ? element.value || (element.meta && element.meta.default)
          : null;
      }
      if (element && element.conditional_logic) {
        if (element.conditional_logic.show === false) {
          value = true;
        }
      }
      if (!value) return false;
    }
    return true;
  };

  _acceptAndSign = () => {
    const { docID, sharingHash } = this.props;
    this.setState({ isLoading: true });
    sharedDocAccepAndSign(docID, sharingHash)
      .then(() => {
        sharedDocAfterAccepAndSign(docID, sharingHash)
          .then(response => {
            const { signingUrl } = response;
            this.setState({
              isLoading: false,
              // showAcceptAndSignBtn: false,
            });
            window.open(signingUrl, "_self");
          })
          .catch(error => {
            this.setState({ isLoading: false });
            console.error(
              `SharedDocumentHeader => _openOneSpan =>sharedDocAfterAccepAndSign => Error : ${error}`,
            );
          });
      })
      .catch(error => {
        this.setState({ isLoading: false });
        console.error(
          `SharedDocumentHeader => _openOneSpan => sharedDocAccepAndSign => Error : ${error}`,
        );
      });
  };

  unfilledFormLoaderText = docFlow => {
    let value = "🔏Processing your document for eSignature";
    if (docFlow === "ACCEPTANCE") {
      value = "🔏Processing document for acceptance";
    }
    return value;
  };

  render() {
    if (!this._checkFormFields() && this.props.view === "submit") {
      const unfilledValue = [];
      const recipentAssignedCount = [];
      this.props.fieldsUsed.forEach(element => {
        if (element.filler_type === "RECIPIENT") {
          if (element.conditional_logic && element.conditional_logic.child_id) {
            if (element.conditional_logic.show) {
              recipentAssignedCount.push(element);
              if (element.value && element.value.length !== 0) {
                unfilledValue.push(element);
              }
            }
          } else {
            recipentAssignedCount.push(element);
            if (element.value && element.value.length !== 0) {
              unfilledValue.push(element);
            }
          }
        }
      });
      const finalFillerValue =
        recipentAssignedCount.length - unfilledValue.length;
      return (
        <SubmitConfirmationPopup
          onConfirm={this._submitConfirmationPopup}
          // onConfirm={this._submitDeclineDoc}
          isLoading={this.state.isLoading}
          onClose={() => {
            this.props.togglePopUp("submitDeclineConfirmation", false);
          }}
          unfilledValue={finalFillerValue || null}
          isSharing={this.props.isSharing}
          docFlow={this.props.docFlow}
        />
      );
    }
    const { usedFor } = this.props;
    if (usedFor && usedFor === "recipient") {
      return (
        <RecipientSubmitDeclinePopup
          onClose={() =>
            this.props.togglePopUp("submitDeclineConfirmation", false)
          }
          isLoading={this.state.isLoading}
          onConfirm={this._submitDeclineDoc}
          view={this.props.view}
          docFlow={this.props.docFlow}
        />
      );
    }
    return (
      <Modal
        open
        onClose={() =>
          this.props.togglePopUp("submitDeclineConfirmation", false)
        }
        center>
        {/* Loader Section */}
        {this.state.isLoading && (
          <LZLoader
            className="loader-bg-color"
            label={` ${
              this.state.isLoading
                ? `${this.unfilledFormLoaderText(this.props.docFlow)}`
                : "Loading..."
            }`}
          />
        )}
        <div className="approvalpopup">
          <div className="approvalpopup-header">
            <p>
              You are about to{" "}
              {this.props.view === "submit" ? "Submit" : "Decline"} document
            </p>
          </div>
        </div>
        <div className="approvalpopup-note">
          <p className="approvalpopup-workflows-heading">
            {this.props.view === "submit"
              ? "Once you click Submit document, you will be restricted to eSign this document."
              : "Are you sure you want to decline this document?"}
          </p>
          <p className="approvalpopup-workflows-heading">
            {this.state.errMsg && (
              <div className="error-message-wrapper">
                <span className="error-message-icon">
                  <FontAwesomeIcon icon={["far", "times-circle"]} />
                </span>
                {this.state.errMsg}
              </div>
            )}
          </p>
        </div>
        <section className="createquotepopup-footer popup-footer clearfix">
          <div className="footer-actions">
            <Button
              data-test="submitdeclineconfirmation-popup-cancelbtn"
              className="btn-transparent"
              onClick={() =>
                this.props.togglePopUp("submitDeclineConfirmation", false)
              }>
              Cancel
            </Button>
            <Button
              type="four"
              data-test="submitdeclineconfirmation-popup-submitbtn"
              className={`${
                this.props.view === "decline" ? "reject-document" : ""
              }`}
              // onClick={() => this._submitDeclineDoc()}
              onClick={this._submitConfirmationPopup}>
              {this.props.view === "submit"
                ? "Submit document"
                : "Decline document"}
            </Button>
          </div>
        </section>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { document, docRecipientList, components, layout } =
    state.DocumentStore;
  const {
    id: docID,
    docNo,
    stage: docStage,
    fields_used: fieldsUsed = [],
    name: docName,
    showForm,
    document_flow: docFlow,
    signatories,
    signatoriesV2,
    isPdfDocument,
  } = document;
  const { documentNotes } = state.NotesStore;
  return {
    docID,
    docNo,
    document,
    docName,
    documentNotes,
    docRecipientList,
    fieldsUsed,
    components,
    showForm,
    layout,
    docFlow,
    signatoriesV2,
    signatories,
    docStage,
    isPdfDocument,
  };
};

export const mapDispatchToProps = {
  updateSubmitRejectSignerFiller: updateSubmitRejectSignerFillerAction,
  updateSubmitDeclineInternal: updateSubmitDeclineInternalAction,
  updateDocStage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubmitDeclineConfirmation);
